import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { de_DE, NZ_DATE_CONFIG, provideNzI18n } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import de from '@angular/common/locales/de';
import { FormsModule } from '@angular/forms';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { AzureModule } from './azure/azure.module';
import { environment } from '../environments/environment';
import { StoreModule } from './store/store.module';
import { authInterceptor } from './interceptor/auth.interceptor';

registerLocaleData(de);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(),
    provideNzI18n(de_DE),
    {
      provide: NZ_DATE_CONFIG,
      useValue: { firstDayOfWeek: 1 },
    },
    importProvidersFrom(
      FormsModule,
      AzureModule.forRoot({
        clientId: environment.auth.clientId,
        scope: environment.auth.apiScopes.base
          .concat(environment.auth.apiScopes.avsApi)
          .join(' '),
        authorizeUri: environment.auth.uri.authorize,
        logoutUri: environment.auth.uri.logout,
        redirectUri: environment.auth.uri.redirect,
        tokenUri: environment.auth.uri.token,
      }),
      StoreModule,
    ),
    provideAnimationsAsync(),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
  ],
};
